import { Button, Form, Modal } from 'antd';

import { DistributionForm } from '../DistributionForm';
import { IDistribution } from 'types/distribution.types';
import dayjs from 'dayjs';

export const EditDistributionModal = ({ open, onOk, onCancel, initialValues = {}, submitting }: any) => {
  const [form] = Form.useForm<IDistribution>();

  const handleReset = () => {
    form.resetFields();
  };

  const handleSubmit = async () => {
    await form.submit();
  };

  return (
    <Modal
      centered
      title="Редактирование рассылки"
      open={open}
      onCancel={onCancel}
      cancelText="Закрыть"
      footer={[
        <Button key="reset" type="text" onClick={handleReset}>
          Очистить
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit} loading={submitting}>
          Сохранить
        </Button>,
      ]}
    >
      <DistributionForm
        isEdit={true}
        form={form}
        onFinish={onOk}
        initialValues={{
          ...initialValues,
          dateToSend: initialValues.dateToSend ? dayjs(initialValues.dateToSend) : undefined,
          age: initialValues.age ? initialValues.age : undefined,
        }}
      />
    </Modal>
  );
};
